// Reduce a raw OS string (e.g. "Microsoft Windows 10.0.26200") to a short display name.
export function osDisplayName(os: string | undefined) {
    if (!os) {
        return undefined
    }
    if (/windows/i.test(os)) {
        return 'Windows'
    }
    if (/mac|darwin/i.test(os)) {
        return 'MacOS'
    }
    if (/android/i.test(os)) {
        return 'Android'
    }
    if (/ios|iphone|ipad/i.test(os)) {
        return 'iOS'
    }
    if (/linux/i.test(os)) {
        return 'Linux'
    }
    return os
}
